import { styled } from '@mui/material/styles';
import { Box, Container, Paper, Stack } from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';

export const PageContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: 'calc(100vh - 80px)',
  width: '100%',
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4, 2),
  overflow: 'hidden',
}));

export const ChatShell = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  maxWidth: 720,
  gap: theme.spacing(3),
  flex: 1,
  minHeight: 0,
  height: '100%',
}));

export const WelcomeHeader = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  textAlign: 'center',
  transition: 'opacity 240ms ease, transform 240ms ease',
  color: theme.palette.text.primary,
  gap: theme.spacing(3),
}));

export const PromptInputShell = styled(Paper)(({ theme, elevated }) => ({
  width: '100%',
  margin: '0 auto',
  backgroundColor: theme.palette.background.paper,
  borderRadius: 28,
  border: 'none', // Removed borders as requested
  boxShadow: elevated
    ? '0 4px 12px rgba(0, 0, 0, 0.08)'
    : '0 2px 8px rgba(0, 0, 0, 0.05)',
  padding: theme.spacing(1, 2),
  display: 'flex',
  alignItems: 'center',
  transition: 'all 220ms ease',
  maxWidth: 680,
}));

export const PromptTextarea = styled(TextareaAutosize)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  border: 'none',
  resize: 'none',
  background: 'transparent',
  color: theme.palette.text.primary,
  fontSize: '1rem',
  lineHeight: 1.5,
  padding: theme.spacing(1.5, 1.5, 1.5, 0),
  '&:focus-visible': {
    outline: 'none',
  },
  '&::placeholder': {
    color: theme.palette.text.secondary,
  },
}));

export const MessageScrollArea = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: theme.spacing(2, 2, 6),
  backgroundColor: '#FFFFFF',
  borderRadius: theme.shape.borderRadius,
  '& > *': {
    marginBottom: theme.spacing(2.5),
  },
  '& > *:last-child': {
    marginBottom: 0,
  },
  '&::-webkit-scrollbar': {
    width: 10,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#D1D5DB',
    borderRadius: 999,
  },
}));

export const MessageGroup = styled(Stack)(({ theme, owner }) => ({
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
  justifyContent: owner === 'user' ? 'flex-end' : 'flex-start',
}));

export const MessageBubble = styled(Paper)(({ theme, owner }) => ({
  maxWidth: '75%',
  padding: theme.spacing(2.25, 2.5),
  borderRadius: theme.shape.borderRadius,
  borderTopLeftRadius: owner === 'assistant' ? 8 : theme.shape.borderRadius,
  borderTopRightRadius: owner === 'user' ? 8 : theme.shape.borderRadius,
  border: 'none', // Removed borders as requested
  background:
    owner === 'user'
      ? 'linear-gradient(140deg, #627CFB 0%, #475CD4 100%)'
      : '#F3F4F6',
  color: owner === 'user' ? '#FFFFFF' : theme.palette.text.primary,
  boxShadow:
    owner === 'user'
      ? '0 2px 8px rgba(98, 124, 251, 0.25)'
      : '0 2px 4px rgba(0, 0, 0, 0.05)',
}));

export const LoadingIndicator = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.75, 2.25),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: '#F3F4F6',
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
}));